<template>
    <div class="pagehead">
        <img src="@/assets/icon/headicon.png" alt="" class="headicon">
        <div class="timer">{{ nowtime }}</div>
        <el-popover
            placement="bottom-start"
            width="200"
            trigger="manual"
            popper-class="menu-popover"
            v-model="visible">
            <div class="user-box" @click="iconclick" slot="reference">
                <div class="head-text">{{ routename }}</div>
                <img src="@/assets/icon/default-user.png" alt="" class="user-img">
                <div class="user-name">{{ username }}</div>
                <img :src="down" alt="" class="user-icon" ref="usericon">
            </div>
            <div @click="passchange" class="manuitem">
                <img :src="password" alt="" class="menu-icon">
                <div class="menu-text">修改密码</div>
            </div>
            <div @click="loginOut" class="manuitem">
                <img :src="logout" alt="" class="menu-icon">
                <div class="menu-text">退出</div>
            </div>
        </el-popover>
        <el-dialog
            :visible.sync="showpass"
            :modal-append-to-body="true"
            custom-class="edit-dialog"
            @close="dialogclose"
            :destroy-on-close="true" 
            :close-on-click-modal ="false"
            width="720px"
            >
            <div slot="title">修改密码</div>
            <div class="edit-content">
                <div class="edit-item">
                    <div class="text">修改密码</div>
                    <el-input
                        class="edit-input"
                        v-model="newword"
                        placeholder="请输入新密码"
                        type="password"
                    ></el-input>
                </div>
                <div class="edit-item">
                    <div class="text">确认密码</div>
                    <el-input
                        class="edit-input"
                        v-model="newword2"
                        placeholder="请再次输入新密码"
                        type="password"
                    ></el-input>
                </div>
            </div>
            <div slot="footer">
                <div class="button-group">
                <el-button type="info" size="small" @click="dialogclose"
                    >取消</el-button
                >
                <el-button type="primary" size="small" @click="confirm"
                    >确定</el-button
                >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Message } from "element-ui";
import moment from 'moment';
import down from '@/assets/icon/down-icon.png'
import password from '@/assets/icon/password.png'
import logout from '@/assets/icon/logout.png'
import router from '@/router';
import { getadminEdit, adminEdit } from '@/api/index'

export default {
    data() {
        return {
            password,
            logout,
            down,
            nowtime: '',
            username: 'StarLand',
            visible: false,
            visible1: false,
            routename: '',
            nameMap: {
                'home': '换针设备',
                'change': '换针数据',
                'machine': '机器二维码',
                'admin': '管理员设置',
            },
            showpass: false,
            newword: '',
            newword2: '',
            userid: '',
            admindata: {}
        }
    },
    mounted() {
        this.gettime()
        this.routename = this.nameMap[this.$route.name]
        this.unwatch = this.$watch('$route', this.routeChanged, { immediate: true });
        var userInfor=localStorage.getItem("userInfor");
        if(userInfor){
            userInfor=JSON.parse(userInfor);
            this.userid = userInfor.id
            this.username=userInfor.department && userInfor.department.name;
        }
        if(!this.username){
            this.username="暂无所属工厂";
        }
    },
    watch: {
    },
    methods: {
        loginOut(type){
            sessionStorage.setItem("token", "");
            if(!type) {
                Message.success("退出登录成功！");
            }
            localStorage.setItem("HomeState","");
            localStorage.setItem("userInfor","");
            localStorage.setItem("token","");	
            window.location.href="/web/#/";
            setTimeout(() => {
                window.location.reload();
            }, 500);            
        },
        gettime() {
            this.nowtime = moment().format('yyyy年MM月DD日  HH:mm:ss');
            setTimeout(() => {
                this.gettime()
            }, 100);
        },
        iconclick() {
            const dom = this.$refs.usericon
            if (dom.style.transform) {
                dom.style.transform = ''
            } else {
                dom.style.transform = 'rotate(180deg)'
            }
            this.visible = !this.visible
        },
        routeChanged(e) {
            this.routename = this.nameMap[e.name]
        },
        passchange() {
            const params = {
                id: this.userid
            }
            getadminEdit(params).then(res => {
                if (res.code == 1) {
                    this.admindata = res.data.row
                    this.showpass = true
                }
            })
        },
        dialogclose() {
            this.showpass = false
        },
        confirm() {
            if (this.newword !== this.newword2) {
                Message.warning("两次输入密码不一致");
                return
            }
            this.admindata.password = this.newword
            adminEdit(this.admindata).then(res => {
                if (res.code == 1) {
                    Message.success("密码更新成功！");
                    this.loginOut(2)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.pagehead {
    height: 64px;
    width: calc(100% - 76px);
    background: #fff;
    box-shadow: 0px 1px 0px 0px #E9EBED;
    display: flex;
    align-items: center;
    padding: 0 44px 0 32px;
    .headicon {
        width: 15.5px;
        height: 15.5px;
    }
    .head-text {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #1C1F28;
        margin-left: 18px;
    }
    .timer {
        margin-left: auto;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #1C1F28;
    }
    .user-box {
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;
    }
    .user-img {
        width: 37px;
        height: 37px;
        border-radius: 50%;
        margin-left: 56px;
    }
    .user-name {
        margin-left: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #1C1F28;
    }
    .user-icon {
        width: 11.5px;
        height: 6.5px;
        margin-left: 20px;
        cursor: pointer;
        transition: all 330ms linear;
    }
}
</style>
<style lang="scss">
.menu-popover {
    padding: 12px 0;
}
.manuitem {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 330ms linear;
    padding: 8px 0;
    .menu-icon {
        width: 12.5px;
        height: 13.5px;
        padding-left: 20px;
    }
    .menu-text {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-left: 12px;
    }
    &:hover {
        background: #F5F7FA;
    }
    & + .manuitem {
        // margin-top: 12px;
    }
}
</style>